import { UnicodeEntity } from '@mews/enums';
import { IconName, Tag } from '@optimus-web/core';

interface LoyaltyMembershipTagProps {
    programName: string;
    tierName?: string;
}

export const LoyaltyMembershipTag = ({ programName, tierName }: LoyaltyMembershipTagProps) => (
    <Tag leadingIcon={IconName.Loyalty} variant="basicSubtle">
        {tierName ? `${programName}${UnicodeEntity.NoBreakSpace}${tierName}` : programName}
    </Tag>
);
